export function formatCurrency(value: number) {
  return `$${Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(value)}`;
}
